import { render, staticRenderFns } from "./DocumentDelivery.vue?vue&type=template&id=94e392f6&scoped=true&"
import script from "./DocumentDelivery.vue?vue&type=script&lang=ts&"
export * from "./DocumentDelivery.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentDelivery.vue?vue&type=style&index=0&id=94e392f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e392f6",
  null
  
)

export default component.exports